import React from "react";

const Movie = ({ url, title }) => (
  <li>
    <img src={url} alt={title} />
  </li>
);

export default Movie;
